import styled from 'styled-components';
import {Popover} from 'react-bootstrap';
import {controlWithIcon} from '../../common/shared/control-with-icon.styled';
import {pageTitle} from '../../common/shared/pageTitle.styled';
import { StyledModal } from '../../common/shared/modal.styled';

export const StyledDebtList = styled.div`
  ${controlWithIcon()}
  ${pageTitle()}
  
  &.building-debt {
    max-width: none;
  }
  .title-section h2 {
    margin-bottom: 0;
  }

  #table {
    max-height: 500px;
  
    tr {
      td.send-request {
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
      }
    }
  }
  
  .center-block{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
 
  .tool {
    width: 32px;
    height: 32px;
    background-color: #E9E9FD;
    border-radius: 50px;
    cursor: pointer;
    transform: rotate(-90deg);
    color: var(--bllink-purple);
    font-weight: 600;

    :hover {
      background: linear-gradient(180deg, #6E8EFF 0%, #8469FF 100%);
      color: #FFFFFF;
    }
  }

  .bllink-input-border {
    padding-left: 60px;
  }

  .title_wrapper {
    display: flex;
    gap: 5px;
  }
`;

export const StyledPopover = styled(Popover)`
  border-radius: 19px;
  padding: 0;

  .popover-body {
    padding: 0;
  }

  .link {
    padding: 10px 17px;
    border-radius: 19px;
    cursor: pointer;

    &:hover {
      background: linear-gradient(90deg, rgba(139, 117, 245, 0.15) 0%, rgba(196, 196, 196, 0) 169.34%);
      color: var(--bllink-purple);
      font-weight: 700;
    }
  }

  .link.disabled {
    pointer-events: none;
    color: rgba(55, 54, 71, 0.5);
  }
`;

export const StyledTenantRecordModal = styled(StyledModal)`
  .close-btn {
    height: 20px;
    font-weight: 300;
    font-size: 36px;
    line-height: .5;
    cursor: pointer;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    padding: 30px !important;

    h1 {
      font-size: 40px;
    }

    h4 {
      text-align: center;
    }

    h5 {
      width: fit-content;
      margin-bottom: 20px;
      font-size: 19px;
    }

    .success-img {
      height: 300px;
    }

    .description-container {
      width: 100%;
      display: flex;
      justify-content: center;

      font-family: var(--bllink-font-primary);
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 30px;
    }

    .description-container div:nth-child(2) {
      margin-inline-start: 10px;
    }
    
    .bllink-button {
      align-self: center;
    }
  }

  .columns {
    display: grid;
    grid-template-columns: 3.5fr 2fr 2fr 0.5fr;
    gap: 20px;

    .wrapper {

      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 13px;
      color: rgba(55, 54, 71, 0.7);

      .header {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 15px;
        display: flex;
        gap: 12px;
        align-items: center;
        color: #373647;
      }

      .name-wrapper {
        display: flex;
        gap: 20px;
      }

      .bllink-input-border {
        height: 35px;
      }
    }


    .edit-icon {
      border: 1px solid #A8C0FF;
      height: fit-content;
      width: fit-content;
      display: flex;
      padding: 8px;
      border-radius: 50px;
      cursor: pointer;
    }
  }

  .modal-header {
    background: linear-gradient(90deg, #6895FF 1.74%, #8C5CFF 100.15%);
    border-radius: 25px 25px 0 0;
    color: #FFFFFF;
  }
`;
